<template>
  <div v-if="galleryType === 'all'" class="flex">
    <div class="slider-gallery__image_print">
      <img :src="images[0]" alt="alt" />
    </div>
    <div class="slider-gallery__image_print">
      <img :src="images[images.length - 1]" alt="alt" />
    </div>
  </div>
  <div v-else>
    <div class="slider-gallery-wrap" ref="mainSwiper" :id="`main-swiper-${leadId}-${galleryType}`">
      <ul class="swiper-wrapper">
        <li v-for="(img, imgIdx) of images" :key="imgIdx" class="swiper-slide swiper-main__slide">
          <div class="slider-gallery__image" :data-src="img" :data-fancybox="dataFancyboxId">
            <img :src="img" alt="alt" :class="imgMobileClass"/>
          </div>
        </li>
      </ul>
      <div v-if="!(isMobile || galleryType === 'layout')" class="slick-prev slick-arrow swiper-main-prev">
        <i class="fas fa-chevron-left"></i>
      </div>
      <div v-if="!(isMobile || galleryType === 'layout')" class="slick-next slick-arrow swiper-main-next">
        <i class="fas fa-chevron-right"></i>
      </div>
    </div>

    <div v-if="!(isMobile || galleryType === 'layout')" class="slider-gallery-wrap swiper swiper-thumb" ref="thumbSwiper" :id="`thumb-swiper-${leadId}-${galleryType}`">
      <ul class="swiper-wrapper swiper-thumbs">
        <li v-for="(img, imgIdx) of images" :key="imgIdx" class="swiper-slide swiper-main__slide swiper-thumb__slide">
          <div class="swiper-thumb__slide__win">
            <img :src="img" alt="alt" class="swiper-thumb__slide__win__img" :class="imgMobileClass"/>
          </div>
        </li>
      </ul>
      <div class="slick-prev slick-arrow swiper-thumb-prev">
        <i class="fas fa-chevron-left"></i>
      </div>
      <div class="slick-next slick-arrow swiper-thumb-next">
        <i class="fas fa-chevron-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Swiper, { Navigation, Thumbs } from 'swiper'
import { Fancybox } from '@fancyapps/ui'
import '@fancyapps/ui/dist/fancybox.css'
import 'swiper/swiper-bundle.min.css'

Swiper.use([Navigation, Thumbs])

export default {
  name: 'Gallery',
  props: {
    images: {
      type: Array,
      required: true,
    },
    leadId: {
      type: Number,
      required: true,
    },
    galleryType: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['isPrint']),
    imgMobileClass() {
      return {
        'mobile-img': this.isMobile,
      }
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    },
  },
  methods: {
    initFancybox() {
      const options = this.isMobile
        ? {
          mainClass: 'fancybox-mobile-container',
          closeButton: 'top',
          Carousel: {
            Navigation: false,
          },
          Toolbar: {
            display: [
              { id: 'counter', position: 'center' },
            ],
          },
        }
        : {
          mainClass: 'fancybox-desktop-container',
          Toolbar: false,
          Carousel: {
            Panzoom: {
              touch: false,
            },
          },
        }
      Fancybox.bind(`[data-fancybox="${this.dataFancyboxId}"]`, {
        dragToClose: false,
        Thumbs: false,
        Image: {
          click: false,
        },
        ...options,
      })
    },
  },
  setup(props) {
    return {
      dataFancyboxId: `rc-fancybox-slide-${props.leadId}`,
    }
  },
  mounted() {
    if (this.isPrint) {
      return
    }
    this.initFancybox()

    const { mainSwiper, thumbSwiper } = this.$refs
    const thumbsSwiper = !(this.isMobile || this.galleryType === 'layout') && new Swiper(`#${thumbSwiper.id}`, {
      slidesPerView: 5,
      allowTouchMove: false,
      navigation: {
          prevEl: '.swiper-thumb-prev',
          nextEl: '.swiper-thumb-next',
        },
      on: {
        touchEnd(s) {
          const range = 5
          const diff = (s.touches.diff === s.isHorizontal())
            ? s.touches.currentX - s.touches.startX
            : s.touches.currentY - s.touches.startY
          if (diff < range || diff > -range) {
            s.allowClick = true
          }
        },
      },
    })

    const swiperOptions = this.isMobile
      ? {
        spaceBetween: 35,
        loop: false,
      }
      : {
        spaceBetween: 35,
        loop: false,
        navigation: {
          prevEl: '.swiper-main-prev',
          nextEl: '.swiper-main-next',
        },
        thumbs: {
          swiper: thumbsSwiper,
        },
      }
    new Swiper(`#${mainSwiper.id}`, swiperOptions)
  },
}
</script>

<style scoped>
.slider-gallery__image img.mobile-img {
  object-fit: contain !important;
  background: black !important;
  border-radius: 0 !important;
  height: 100% !important;
  width: 100% !important;
}
</style>

<style>
.fancybox-mobile-container .fancybox__backdrop::after {
  opacity: 0;
}

.fancybox-mobile-container {
  --fancybox-bg: #000;
}

.fancybox-desktop-container .carousel__button.is-close {
  color: #1a1a1a !important;
  top: 14px !important;
  right: 14px !important;
  width: 20px !important;
  height: 20px !important;
  border: 2px solid !important;
  border-color: #1a1a1a !important;
}

.fancybox-desktop-container .carousel__button.is-close svg {
  padding: 3px !important;
}

.swiper-thumb {
  margin-top: 20px;
}

.swiper-thumb__slide {
  margin-bottom: 10px;
}

.swiper-thumb__slide__win {
  position: relative;
  margin: 2px;
  height: 100px;
}

.swiper-thumb__slide__win__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-slide-thumb-active .swiper-thumb__slide__win::after {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  height: 100%;
  width: 100%;
  border: 2px solid rgb(23 175 79);
}

.swiper-thumb-prev {
  left: 10px !important;
  background-color: transparent !important;
  font-size: 30px !important;
}
.swiper-thumb-next {
  right: 10px !important;
  background-color: transparent !important;
  font-size: 30px !important;
}

.flex {
  display: flex;
}
.slider-gallery__image_print {
  height: 30vh;
  width: 50vw;
}

.slider-gallery__image_print img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}
</style>
